module.exports = __webpack_public_path__ + "img/full_screen.47fd6e96.svg";